// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles-module__values___QAFAh{padding:6px 0}`, "",{"version":3,"sources":["webpack://./src/pages/RS-Workspace/components/Results/components/Elements/components/ParameterValues/styles.module.scss"],"names":[],"mappings":"AACA,+BACE,aAAA","sourcesContent":["\n.values {\n  padding: 6px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export var values = `styles-module__values___QAFAh`;
export default ___CSS_LOADER_EXPORT___;
